import styled from "styled-components";

export const EmptyTableWrapper = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyTableContainer = styled.div`
  width: 90%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 10px;
  border: 4px dashed var(--border-color);
  border-radius: 2em;
  padding: 50px 5px;

  svg {
    width: auto;
    max-width: 100%;
    height: 60px;

    @media only screen and (max-width: 767px) {
      height: 50px;
    }
  }

  h4 {
    font-weight: 400;
    margin: 0;
  }
`;